// お問い合わせ種別で「その他」を選んだ時だけ、その他種別の項目を表示する
// (入力必須かどうかはサーバー側の入力チェックに任せるため、requiredは付けない。
//  他の必須項目もHTML5のrequiredではなく、サーバー側チェック＋赤文字表示で統一している)
const contactForm = document.querySelector( ".js-contact-form" );

if ( contactForm )
{
    const inquiryTypeInputs = contactForm.querySelectorAll( 'input[name="inquiry_type"]' );
    const otherTypeFieldset = contactForm.querySelector( ".js-contact-other-type" );
    const otherTypeInputs = contactForm.querySelectorAll( 'input[name="other_type"]' );

    // 選択中のお問い合わせ種別に応じて、その他種別欄の表示を更新する
    const updateOtherTypeVisibility = () =>
    {
        const selected = contactForm.querySelector( 'input[name="inquiry_type"]:checked' );
        const isOther = selected && selected.value === "other";

        if ( !otherTypeFieldset )
        {
            return;
        }

        otherTypeFieldset.hidden = !isOther;

        if ( !isOther )
        {
            otherTypeInputs.forEach( ( input ) =>
            {
                input.checked = false;
            } );
        }
    };

    inquiryTypeInputs.forEach( ( input ) =>
    {
        input.addEventListener( "change", updateOtherTypeVisibility );
    } );

    updateOtherTypeVisibility();
}
